import { createFileRoute } from "@tanstack/react-router";
import { Activity, Cable, Gauge, PlugZap, ShieldCheck, Thermometer } from "lucide-react";
import { AppShell } from "@/faults-app/components/app-shell";

export const Route = createFileRoute("/tools")({
  head: () => ({
    meta: [
      { title: "أدوات القياس الكهربائية" },
      {
        name: "description",
        content:
          "دليل عربي مختصر لأجهزة القياس: الملتيميتر، الكلامب ميتر، الميغر، واختبار الاستمرارية والتأريض.",
      },
      { property: "og:title", content: "أدوات القياس الكهربائية" },
      { property: "og:description", content: "كيف تستخدم أجهزة القياس أثناء تشخيص الأعطال." },
    ],
  }),
  component: Tools,
});

const TOOLS = [
  {
    icon: Gauge,
    name: "الملتيميتر (Multimeter)",
    use: "قياس الفولتية AC/DC، المقاومة، والاستمرارية.",
    tip: "لقياس الفولتية ضع الأطراف بين L1 و L2 واضبط الجهاز على AC Voltage.",
  },
  {
    icon: Activity,
    name: "الكلامب ميتر (Clamp Meter)",
    use: "قياس تيار المحرك بدون فصل الدائرة.",
    tip: "قارن التيار المقاس مع التيار المكتوب على لوحة المحرك (Name Plate).",
  },
  {
    icon: ShieldCheck,
    name: "الميغر (Insulation Tester)",
    use: "قياس عزل الملفات والكابلات.",
    tip: "قراءة أقل من 1 ميغا أوم تعني ضعف عزل ويجب المعالجة.",
  },
  {
    icon: Cable,
    name: "اختبار الاستمرارية (Continuity)",
    use: "فحص الأسلاك ونقاط التماس NO/NC.",
    tip: "افصل التغذية قبل اختبار الاستمرارية لتجنب الضرر والخطر.",
  },
  {
    icon: PlugZap,
    name: "قلم كشف الفولتية",
    use: "كشف وجود جهد بسرعة قبل العمل.",
    tip: "أداة تحذيرية فقط ولا تعتمد عليها لتأكيد انعدام الجهد.",
  },
  {
    icon: Thermometer,
    name: "كاميرا/مقياس حرارة",
    use: "كشف نقاط الربط الساخنة في اللوحات.",
    tip: "أي نقطة أسخن من محيطها تعني ربطاً مرتخياً أو تحميلاً زائداً.",
  },
];

function Tools() {
  return (
    <AppShell>
      <main className="mx-auto w-full max-w-4xl px-4 pt-6">
        <header className="rounded-3xl panel-dark p-5 shadow-card">
          <h1 className="flex items-center gap-2 text-xl font-extrabold text-white">
            <Gauge className="h-6 w-6 text-primary" /> أدوات القياس
          </h1>
          <p className="mt-1 text-sm text-white/80">
            استخدم الجهاز الصحيح لكل اختبار، والتزم دائماً بتحذيرات السلامة.
          </p>
        </header>

        <div className="mt-4 grid gap-3 sm:grid-cols-2">
          {TOOLS.map((t) => (
            <article key={t.name} className="card-tech p-4">
              <div className="flex items-start gap-3">
                <span className="grid h-12 w-12 shrink-0 place-items-center rounded-2xl bg-linear-to-br from-primary to-primary-glow text-primary-foreground shadow-glow">
                  <t.icon className="h-6 w-6" />
                </span>
                <div className="min-w-0">
                  <h2 className="text-base font-extrabold">{t.name}</h2>
                  <p className="mt-1 text-sm text-muted-foreground">{t.use}</p>
                </div>
              </div>
              <p className="mt-3 rounded-xl border border-primary/30 bg-accent/50 p-3 text-xs font-bold text-accent-foreground">
                {t.tip}
              </p>
            </article>
          ))}
        </div>
      </main>
    </AppShell>
  );
}
